var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParentLine = function SvgParentLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 9.3a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5m0 1.8a4.05 4.05 0 1 1 0-8.101A4.05 4.05 0 0 1 8 11.1m9.45 1.8a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6m0 1.8a3.6 3.6 0 1 1 0-7.2 3.6 3.6 0 0 1 0 7.2m2.25 5.4v-.45a2.25 2.25 0 0 0-4.5 0v.45h-1.8v-.45a4.05 4.05 0 0 1 8.1 0v.45zm-9 0v-3.6a2.7 2.7 0 0 0-5.4 0v3.6H3.5v-3.6a4.5 4.5 0 1 1 9 0v3.6z"
  })));
};
export default SvgParentLine;